import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    buttonContainer: {
        width: '50%',
        display: "flex",
        padding: "1em"
    },
    title: {
        marginTop: '40px',
        marginBottom: theme.spacing(3)
    },
    button: {
        width: '75%',
        marginBottom: theme.spacing(1),
    },
    cancelbtn: {
        width: '75%',
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    buttonProgress: {
        color: theme.palette.secondary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
}));


export default useStyles;